// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '172739e47f23219b2b492f2e4836c429f726fe80';
export const BUILD_NUMBER = '251';
export const BUILD_TIMESTAMP = '2026-09-25T04:13:33.141Z';
